






























import { Component, Prop, Vue } from 'vue-property-decorator'
import { Game } from '@/class/game'
import { MASTER_ROLE } from '@/class/const'
import { ReadyPlayer } from '@/class/room'
import { RoleId } from '@/enum'
import Card from '@/components/Common/Card/Card.vue'
import SimpleModal from '@/components/Utils/modal/SimpleModal.vue'
import Radio from '@/components/Utils/form/radio/Radio.vue'
import HeadlineBorder from '@/components/Utils/headline/HeadlineBorder.vue'

@Component({
  components: {
    Card,
    SimpleModal,
    Radio,
    HeadlineBorder
  }
})
export default class PriorityRoleSelecter extends Vue {
  @Prop() game!: Game;
  @Prop() self!: ReadyPlayer;
  @Prop() isGallary!: boolean;

  get masterRole () {
    return MASTER_ROLE
  }

  get selectablePriorityRole () {
    return this.self.selectablePriorityRole
  }

  setRole (roleId: RoleId) {
    this.game.setRole(this.self.id, roleId)
  }

}
